module.exports = __webpack_public_path__ + "static/media/flask-potion.335d5696.svg";